import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LandingPage } from './features/landing/LandingPage.js';
import { BoardEntry } from './features/board/BoardEntry.js';

const root = document.getElementById('root');
if (!root) throw new Error('Missing root element');
async function start() {
  const publicHost = ['nerdsatplay.org', 'www.nerdsatplay.org'].includes(window.location.hostname);
  if (publicHost && window.location.pathname.replace(/\/$/, '') === '/board') {
    window.location.replace(
      'https://play.nerdsatplay.org/' + window.location.search + window.location.hash,
    );
    return;
  }
  let Component =
    publicHost || (import.meta.env.DEV && window.location.pathname === '/landing')
      ? LandingPage
      : BoardEntry;
  // Build-time boundary: fictional previews and legacy pages never ship as routes.
  if (import.meta.env.DEV) {
    const path = window.location.pathname.replace(/\/$/, '');
    if (path === '/dev/board') {
      Component = (await import('./features/board/BoardPreview.js')).BoardPreview;
    } else if (path === '/dev' || path === '/dev/preview') {
      await import('./styles.css');
      Component =
        path === '/dev'
          ? (await import('./features/dev/DevWalkthrough.js')).DevWalkthrough
          : (await import('./features/dev/Preview.js')).Preview;
    }
  }
  createRoot(root!).render(
    <StrictMode>
      <Component />
    </StrictMode>,
  );
}
void start();
